var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-carousel',{attrs:{"cycle":""}},_vm._l((_vm.images),function(image,index){return _c('v-carousel-item',{key:index,attrs:{"src":image.src}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }